import { AutoSendCard } from "./AutoSendCard";
import { post } from "../js/post";
import {
  autoSendStructure,
  formatValueUnit,
  selectedOptic,
  userData,
} from "../js/utils";
import { useEffect, useState } from "react";

export function AutoSend() {
  const [data, setData] = useState(autoSendStructure);

  // console.log("AUTOSENDS: ", data);

  async function getAutosends() {
    const response = await post("support-extra/crm/ObtenerAutosends.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
    });
    setData(response);
  }

  useEffect(() => {
    getAutosends();
  }, []);

  return (
    <div className="crm-autosend-container thin-rounded-border">
      <div className="container-panel" style={{ width: "100%" }}>
        <div className="opt-table-content grid-8" id="autosend-summary-grid">
          <div className="cell cell-label cell-start-content">Saldo SMS</div>
          <div className="cell cell-start-content">
            {formatValueUnit(data.saldoSMS)}
          </div>
          <div className="cell"></div>
          <div className="cell cell-label cell-start-content">Saldo RCS</div>
          <div className="cell cell-start-content">
            {formatValueUnit(data.saldoRCS)}
          </div>
          <div className="cell"></div>
          <div className="cell cell-label cell-start-content">Remitente</div>
          <div className="cell cell-start-content">{data.remitente}</div>
        </div>
      </div>
      <AutoSendCard
        category={0}
        data={data.cumpleanos}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={1}
        data={data.recordatorioCitas}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={2}
        data={data.revisionesOptometria}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={3}
        data={data.revisionesLC}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={4}
        data={data.revisionesAudiometria}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={5}
        data={data.comunicacionTrasVenta}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={6}
        data={data.comunicacionTrasVentaGafas}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={7}
        data={data.comunicacionTrasVentaLC}
        onCloseASPatients={getAutosends}
      />
      <AutoSendCard
        category={8}
        data={data.comunicacionTrasVentaAudifono}
        onCloseASPatients={getAutosends}
      />
    </div>
  );
}
